export const RECRUITMENT_REQUEST_PERMISSION_CODES = {
    WEB_RECRUITMENT_REQUEST_LIST: 'WEB_RECRUITMENT_REQUEST_LIST',
    WEB_RECRUITMENT_REQUEST_DETAIL: 'WEB_RECRUITMENT_REQUEST_DETAIL',
    WEB_RECRUITMENT_REQUEST_ADD: 'WEB_RECRUITMENT_REQUEST_ADD',
    WEB_RECRUITMENT_REQUEST_EDIT: 'WEB_RECRUITMENT_REQUEST_EDIT',
    WEB_RECRUITMENT_REQUEST_DELETE: 'WEB_RECRUITMENT_REQUEST_DELETE',
    WEB_RECRUITMENT_REQUEST_IMPORT: 'WEB_RECRUITMENT_REQUEST_IMPORT',
    WEB_RECRUITMENT_REQUEST_EXPORT: 'WEB_RECRUITMENT_REQUEST_EXPORT',
} as const;

